/**
 * Hard-navigation seam for ending impersonation (goal 048).
 *
 * After `stop-impersonating` restores the admin session cookie, a FULL document
 * navigation (not a client-side router push) guarantees the swapped-back cookie
 * and a fresh session store are used for the admin view — no stale
 * impersonated-session state lingers in the client. Isolated in its own module
 * so component tests can mock the navigation without wrestling jsdom's
 * non-configurable `window.location`.
 */
export function redirectToAdminUsers(): void {
  window.location.assign('/admin/users')
}
